import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import SVG from '@glowforge/gf-styled/src/components/svg';
import TopNav from '@glowforge/gf-styled/src/components/navigation/top-nav';
import Button from '@glowforge/gf-styled/src/components/button';
import { GLOWFORGE_STORE } from '../../route-constants';
import { withUser, userContextPropType } from '../../context/UserContext';
import { withFeatureFlags } from '../../context/FeatureFlagsContext';
import getNavbarConfig from './config';

function Navbar(props) {
  const {
    user,
    userFetchState,
    featureFlags,
    ctaLocation,
    ctaText,
    includeBuyButton,
    router: { pathname },
  } = props;

  const config = getNavbarConfig(featureFlags);

  // userRoutes in the config are coming back as an object
  // and not an array like routes does.
  // But just in case it turns into an array, let's be safe
  const userRoutes =
    typeof config.userRoutes === 'object'
      ? Object.values(config.userRoutes)
      : config.userRoutes;
  const primaryRoutes = config.routes.filter((route) => !route.disabled);

  return (
    <TopNav
      user={user}
      userFetchState={userFetchState}
      buttonSection={
        includeBuyButton ? (
          <Button href={ctaLocation} className='buyButton' type='primary'>
            {ctaText}
            &nbsp;
            <SVG id='long-arrow-right' />
          </Button>
        ) : null
      }
      routes={{
        primaryRoutes,
        userRoutes,
      }}
      activeLink={pathname}
    />
  );
}

Navbar.propTypes = {
  ctaText: PropTypes.string,
  ctaLocation: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  featureFlags: PropTypes.object,
  includeBuyButton: PropTypes.bool,
  router: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  ...userContextPropType,
};

Navbar.defaultProps = {
  ctaText: 'Buy Glowforge',
  ctaLocation: GLOWFORGE_STORE.BASE_URI,
  featureFlags: {},
  includeBuyButton: true,
};

export default withFeatureFlags(withUser(withRouter(Navbar)));
